import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class MessageTemplateGrid extends BaseComponent {
	
	static get properties() {
		return {				
		};
	}
	
	constructor() {
		super();
		
		var messageTemplateGrid = this;
		setTimeout(function(){
			messageTemplateGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var messageTemplateGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_MESSAGE_TEMPLATES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',					
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_MESSAGE_TEMPLATES:WRITE'],
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'activate',					
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_MESSAGE_TEMPLATES:UPDATE_STATUS'],
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Toggle Status')
					],
					listeners: {
						click: function() {							
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}					
				},				
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',					
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					disabled: true,	
					permissions: ['ADMIN_MESSAGE_TEMPLATES:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}				
				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'templateId',
					header: 'Template Id',
					width: '7em'
				},
				{						
					path: 'templateTypeDescription',
					header: 'Type',
					width: '7em'
				},
				{
					path: 'description',
					header: 'Description',
					width: '12em'
				},				
				{
					path: 'activeStatus',
					header: 'Active Status',
					width: '7em'
				},
				{
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					renderer: function(root, column, rowData) {	
						root.innerHTML = TimeUtil.formatDateStandard(TimeUtil.parseDate(rowData.item.updateDts));
					}
				},
				{
					path: 'updateUser',
					header: 'Update User',
					width: '7em'										
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;							
						ElementUtil.query(toolbar, 'activate').disabled = false;	
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'activate').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;						
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		messageTemplateGrid.append(flexLayout);		
				
		var actionRefresh = function() {
			var loadMask = grid.showLoading();	
			Service.getMessageTemplateService().getAllTemplates().then(function(data){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = data;				
			});
		};
		actionRefresh();
		
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
											
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',
											itemid: 'templateTypeCB',
											name: 'templateType',
											label: 'Template Type',
											'item-value-path': 'code',
											'item-label-path': 'description',																	
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('MessageTemplateType').then(function (data) {													
													combo.items = data;
													combo.required = true;
												});
											},
											placeHolder: 'Select'											
										},
										{
											tag: 'vaadin-text-field',										
											name: 'description',
											label: 'Description',											
											required: true,
											maxLength: 255											
										},
										{
											tag: 'vaadin-text-area',										
											name: 'template',
											label: 'Template',
											style: 'max-height: 400px;',
											required: true,
											colspan: 2,
											maxLength: 1000000											
										},									
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																																
															formPanel.submitForm({
																preSubmit: function (data) {														
																	return data;
																},
																actualCall: function (data) {
																	if (record) {
																		data.templateId = record.templateId;
																	}
																	return Service.getMessageTemplateService().saveTemplate(data, (record ? true : false));
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Message Template', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						if (record) {
							formPanel.load(record);
						}
						
					}
				}
			});						
			
			
			
			

			
		};
		
		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating...');	
			if (record.activeStatus === 'A') {
				Service.getMessageTemplateService().inactivateTemplate(record.templateId).then(function(){
					loadMask.remove();				
					actionRefresh();
				});	
			} else {
				Service.getMessageTemplateService().activateTemplate(record.templateId).then(function(){
					loadMask.remove();				
					actionRefresh();
				});
			}
		};
		
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete template: ' + record.description  + ' ?<br><br>This will remove the template from associated Company Types.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting template...');													

							Service.getMessageTemplateService().deleteTemplate(record.templateId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted template: ' + record.description, {									
									theme: 'success'
								});
								actionRefresh();
							});															

						}	
					},
					{
						text: 'No'
					}
				]
			});				
			
		};
		
	}
	
};
customElements.define('dl-message-template-grid', MessageTemplateGrid);


